import { queryOptions, useQuery } from '@tanstack/react-query';
import { client, SessionImageCandidateDTO } from '../../generated';
import { ApiError } from '../../../components/ApiLoadingGuard/ApiLoadingGuard';

export const selfServiceSessionImagesKeys = {
  base: ['selfServiceSessionImages'] as const,
  list: ({ jobsiteId, sessionId }: SelfServiceImagesOptionsProps) =>
    [...selfServiceSessionImagesKeys.base, jobsiteId, sessionId] as const,
};

interface SelfServiceImagesOptionsProps {
  jobsiteId: string | undefined;
  sessionId: string | undefined;
}

function selfServiceImagesOptions({ jobsiteId, sessionId }: SelfServiceImagesOptionsProps) {
  return queryOptions<SessionImageCandidateDTO[], ApiError>({
    queryKey: selfServiceSessionImagesKeys.list({ jobsiteId, sessionId }),
    queryFn: async () => {
      if (!jobsiteId || !sessionId) throw new Error('jobsiteId and sessionId are required');

      const response = await client.get<SessionImageCandidateDTO[], ApiError>({
        url: `/api/self-service/jobsites/${jobsiteId}/${sessionId}/images`,
      });

      if (response.data !== undefined) {
        return response.data;
      } else {
        throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!jobsiteId && !!sessionId,
  });
}

export function useSelfServiceImages(props: SelfServiceImagesOptionsProps) {
  return useQuery(selfServiceImagesOptions(props));
}
